module.exports = "<app-header></app-header>\n<app-historic></app-historic>\n<router-outlet></router-outlet>\n"